import React from 'react';
import RowWrapper from './RowWrapper';
var TorpedoContentStrip = function (_a) {
    var children = _a.children, width = _a.width;
    return (React.createElement(RowWrapper, { style: {
            width: width,
        } }, children));
};
TorpedoContentStrip.displayName = 'TorpedoContentStrip';
export default React.memo(TorpedoContentStrip);
//# sourceMappingURL=ContentStrip.js.map